import styles from "./styles.module.scss";
import cn from "classnames";

export const MissionCriticalProjects = ({ subtitle, title, projects, ctaText, ctaHref }) => {
  // A helper function to render a single project card
  const renderProjectCard = (project, key) => {
    const { tag, headline, image, link } = project;
    return (
      <div key={key} className={styles.projectCard} style={{ backgroundImage: `url(${image?.url})` }}>
        <div className={styles.projectOverlay}>
          <span className={styles.tag}>{tag}</span>
          {/* New row for headline and plus icon */}
          <div className={styles.headlineRow}>
            <h3>{headline}</h3>
            <a href={link || "#"} className={styles.plusIconLink} aria-label={`View project: ${headline}`}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C9.40292 0 8.91892 0.484027 8.91892 1.08108V8.91895H1.08108C0.484027 8.91895 0 9.40295 0 10C0 10.5971 0.484027 11.0811 1.08108 11.0811H8.91892V18.9189C8.91892 19.516 9.40292 20 10 20C10.5971 20 11.0811 19.516 11.0811 18.9189V11.0811H18.9189C19.516 11.0811 20 10.5971 20 10C20 9.40295 19.516 8.91895 18.9189 8.91895H11.0811V1.08108C11.0811 0.484027 10.5971 0 10 0Z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className={styles.MissionCriticalProjects}>
      <div className={styles.textBlock}>
        <div className={styles.subtitle} data-sourceflow-prop="subtitle">
          {subtitle}
        </div>
        <div className={styles.title} data-sourceflow-prop="title">
          {title}
        </div>
      </div>

      <div className={styles.projectRow}>
        {projects.slice(0, 2).map((project, i) => renderProjectCard(project, i))}
      </div>

      <div className={styles.projectRow}>
        {projects.slice(2, 5).map((project, i) => renderProjectCard(project, i + 2))}
      </div>

      {ctaText && ctaHref && (
        <a href={ctaHref} className={styles.viewMore}>
          <span>{ctaText}</span>
        </a>
      )}
    </section>
  );
};

export default MissionCriticalProjects;